"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipContainerStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _tooltipTheme = require("../tooltipTheme");
const TooltipContainerStyled = (0, _styled.default)("div")(_ref => {
  let {
    themeMode
  } = _ref;
  return `
        background-color: var(--sds--tooltip--background-color, ${_tooltipTheme.tooltipTheme.background(themeMode)});
        border-radius: ${_tooltipTheme.tooltipTheme.borderRadius(themeMode)};
        color: var(--sds--tooltip--text-color, ${_tooltipTheme.tooltipTheme.textColor.body(themeMode)});
        max-width: 256px;
        // Allow breaking inside words so the max-width will work even when a single word is > 256px wide.
        overflow-wrap: break-word;

        font-size: ${_tooltipTheme.tooltipTheme.fontSize.basic(themeMode)};
        line-height: ${_tooltipTheme.tooltipTheme.lineHeight.body(themeMode)};
        font-weight: ${_tooltipTheme.tooltipTheme.fontWeight.body(themeMode)};
    `;
}, _ref2 => {
  let {
    squareCorner
  } = _ref2;
  return squareCorner && {
    [`${squareCorner}Radius`]: 0
  } || "";
});
exports.TooltipContainerStyled = TooltipContainerStyled;
//# sourceMappingURL=TooltipContainerStyled.js.map